export const prices = {
    small: 2700,
    medium: 3600,
    suv: 3800,
    large: 4100,
}